module.exports = __webpack_public_path__ + "static/a2-e3a0dd56c5499f16d9ea823b5c6ddc03.png";